export default ({
    name : 'ProductBest'
    , data () {
        return {
            productList : []
            , originProductList : []
            , viewCart : viewCart
        }
    }
    , created () {
        this.code = 'product_best';
        this.basic = this.getDetailDataByCode(this.code);
        //this.getProductBestList();
        if (
            typeof this.basic.data.product_list !== 'undefined' && 
            typeof this.basic.data.product_list.value !== 'undefined' && 
            this.basic.data.product_list.value.length > 0
        ) {
            this.originProductList = this.basic.data.product_list.value; 
            this.setProductListFromChangedLimit();
        }
        sessionStorage.setItem('productId', this.basic.data.product_id.value);
        return {}
    }
    , mounted () {
    }
    , computed : {
        isShowType1 () {
            if (this.getShowTypeValue() == this.getShowTypeEnumValue(0)) return true;
            return false;
        }
        , isShowType2 () {
            if (this.getShowTypeValue() == this.getShowTypeEnumValue(1)) return true;
            return false;
        }
        , isShowType3 () {
            if (this.getShowTypeValue() == this.getShowTypeEnumValue(2)) return true;
            return false;
        }
        , title () {
            if (this.basic.data.title.value.length == 0) return this.basic.data.title.default
            return this.basic.data.title.value
        }
        , rows () {
            let rows = parseInt(this.basic.data.rows.value)
            return isNaN(rows) ? 3 : rows 
        }
        , changeRowsEng () {
            switch (this.rows) {
                case 2: return 'two'
                case 3: return 'three'
                case 4: return 'four'
                case 5: return 'five'
            }
            return 'three'
        }
        , isDefaultValue () {
            return (this.productList.length < 1 || this.basic.data.product_id.value.length < 1)
        }
        , productBestDefaultImg () {
            //return `${this.baseURI}/assets/shop/img/temp/noimg_product_best.png`
            return `//image.makeshop.co.kr/mysoho/assets/shop/img/temp/noimg_product_best.png`
        }
    }
    , methods : {
        getShowTypeValue () {
            return this.basic.data.show_type.value;
        }
        , getShowTypeEnumValue (key) {
            return this.basic.data.show_type.enums[key];
        }
        , getLimit () {
            return Number(this.basic.data.rows.value) * Number(this.basic.data.column.value)
        }
        , getProductBestList () {
            let params = new FormData()
            //params.append('limit', this.getLimit())
            params.append('limit', this.basic.data.product_id.value.length)
            params.append('prd_ids', this.basic.data.product_id.value)

			this.$http.post(`${this.baseURI}/main/ajaxGetProductBestList`, params, { headers : this.axiosCommonHeader } 
            ).then(response => {
                if (response.data.length == 0) {
                    return
                }
                this.originProductList = response.data.list
                this.setProductListFromChangedLimit()
            }).catch(error => {
                return
            })
        }
        , getPayUrl (productId, stockType) {
            /*if (this.isSoldOutStockType(stockType)) {
                return 'javascript:void(0);'
            }*/
            return 'javascript:check_cart(' + productId + ');'
        }
		, getCartUrl (stockType) {
            if (this.isSoldOutStockType(stockType) || this.getAdminEditMode()) {
                return ''
            }
            return (viewCart) ? 'MSH-btn-cart-add' : 'MSH-display-none'
        }
		, goPayUrl (productId, stockType) {
            if (this.getAdminEditMode()) {
                return false
            }
            return check_cart(productId)
        }
		, getSoldoutClassName (stockType) {
            if (this.isSoldOutStockType(stockType)) return 'soldout'
            return ''
        }
        , isSoldOutStockType (stockType) {
            if (stockType == 'soldout') return true
            return false
        }
        , setProductListFromChangedLimit () {
            let product = []
            if (this.originProductList.length == 0) { 
                this.productList = product 
                return
            }
            let limit = (this.getLimit() > this.originProductList.length) ? this.originProductList.length : this.getLimit()
            for (let i=0; i < limit; i++) {
                product[i] = this.originProductList[i]
            }
            this.productList = product 
        }
        , isMoreGetProductBestList () {
            let prdIds = this.basic.data.product_id.value
            let storagePrdIdStr = sessionStorage.getItem('productId')
            let storagePrdIds = storagePrdIdStr.split(',')
            let isMore = false
            let sortProductList = []
            for (let i=0; i < prdIds.length; i++) {
                let chkPrdId = prdIds[i].toString()
                if (storagePrdIds.indexOf(chkPrdId) < 0) {
                    isMore = true
                    break
                }
            }
            if (isMore === true) {
                sessionStorage.setItem('productId', this.basic.data.product_id.value)
                this.getProductBestList()
                return
            }
            // sort 
            for (let i=0; i< prdIds.length; i++) {
                let chkPrdId = prdIds[i].toString()
                let idx = storagePrdIds.indexOf(chkPrdId)
                sortProductList[i] = this.originProductList[idx]
            }
            this.originProductList = sortProductList
            this.setProductListFromChangedLimit()
            sessionStorage.setItem('productId', this.basic.data.product_id.value)
        }
    }
    , updated () {
        if (this.basic.data.product_id.value.length > 0 && this.basic.data.product_id.value != sessionStorage.getItem('productId')) {
            this.isMoreGetProductBestList()
        }
        let limit = (this.getLimit() > this.originProductList.length) ? this.originProductList.length : this.getLimit()
        if (limit > this.productList.length) {
            this.setProductListFromChangedLimit()
        }
    }
})
